import cn from 'clsx'
import useTranslation from 'next-translate/useTranslation'
import { CheckoutStep, checkoutSteps } from '@lib/api'

interface BreadcrumbStepProps {
  text: string
  isActive: boolean
}
const BreadcrumbStep = ({ text, isActive }: BreadcrumbStepProps) => (
  <span className={cn('text-white', { 'font-bold': isActive })}>{text}</span>
)

interface BreadcrumbProps {
  currentStep: CheckoutStep | undefined
}
export const Breadcrumb = ({ currentStep }: BreadcrumbProps) => {
  const { t } = useTranslation()
  const stepNames: Record<CheckoutStep, string> = {
    EnteringShippingAddress: t('checkout:shipping_address'),
    EnteringShippingMethod: t('checkout:shipping_method'),
    ArrangingPayment: t('checkout:payment'),
  }

  return (
    <div className="hidden lg:block">
      {checkoutSteps.map((step, index) => (
        <>
          <BreadcrumbStep
            key={step}
            isActive={step === currentStep}
            text={stepNames[step]}
          />
          {index < checkoutSteps.length - 1 ? (
            <span className="mx-2.5">{'>'}</span>
          ) : null}
        </>
      ))}
    </div>
  )
}
